import { useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openBulkCancelModal } from '../../../store/orders/edit-order/edit.order.actions';
import { useOneOrMoreOrderSelectedDisabled } from '../disabled-hooks/use-one-or-more-order-selected-disabled';
import { ShipmentConfigurationService } from '../../../services/shipping-configuration-service';
import { messages } from './messages';

export const useCancelOrder = () => {
  const dispatch = useDispatch();
  const oneOrMoreOrderSelectedDisabled = useOneOrMoreOrderSelectedDisabled();
  const isShippedPendingFulfillmentOrCancelledOrderSelected = useSelector(
    (state) => ShipmentConfigurationService.orderSelectionContainsShippedPendingFulfillmentOrCancelledShipments(state) || false,
  );

  let disabledReason = null;
  if (isShippedPendingFulfillmentOrCancelledOrderSelected) {
    disabledReason = messages.cancelDisabledReason;
  }

  const actionHandler = useCallback(() => {
    dispatch(openBulkCancelModal());
  }, [dispatch]);

  return useMemo(() => {
    return {
      actionHandler,
      nameDescriptor: messages.orderGridOtherActionsCancelOrder,
      isDisabled: oneOrMoreOrderSelectedDisabled || isShippedPendingFulfillmentOrCancelledOrderSelected,
      disabledReason,
    };
  }, [actionHandler, disabledReason, isShippedPendingFulfillmentOrCancelledOrderSelected, oneOrMoreOrderSelectedDisabled]);
};
